<template>
  <section>
    <salary-intro></salary-intro>
    <input-bar></input-bar>
    <gamer-details></gamer-details>
    <gamer-footer></gamer-footer>
  </section>
</template>

<style lang="scss" scoped>
  
</style>

<script>
import SalaryIntro from "@/components/GamerSalary/SalaryIntro";
import InputBar from "@/components/GamerSalary/InputBar";
import GamerDetails from "@/components/GamerSalary/GamerDetails";
import GamerFooter from "@/components/GamerSalary/GamerFooter";

export default {
  components: {
    SalaryIntro,
    InputBar,
    GamerDetails,
    GamerFooter,
  },
};
</script>